import { generateForm, setFormParam, submitForm } from 'app/libs/form';
import { useCallback } from 'react';

function useForm() {
	/**
	 *
	 * @param {*} form : 새로 생성된 form
	 * @param {*} formData  : {name,value} or [ [name, value],[name, value].. ]
	 */

	const mappingForParam = (form, formData) => {
		if (!formData) return;

		if (Array.isArray(formData)) {
			formData.forEach(([name, value]) => setFormParam(form, [name], value));
			return;
		}

		if (typeof formData === 'object' && Object.keys(formData).length > 0) {
			Object.entries(formData).forEach(([name, value]) => {
				setFormParam(form, [name], value);
			});
		}
	};
	const handleForm = useCallback((method, url, formData, target = '_self', popupOptions) => {
		if (target !== '_self' && target !== '_blank') {
			window.open('', target, popupOptions);
		}

		const postForm = generateForm(method, url, target);
		mappingForParam(postForm, formData);
		submitForm(postForm);
	}, []);

	return { handleForm };
}

export default useForm;
